/**
* @Author: zachalam
* @Date:   2017-03-21T14:27:30-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-03-21T14:27:30-07:00
*/

import * as sdk from '../sdk';
import { storeMeta } from './metaActions';

export const requestSearch = () => {
  return {
    type: 'REQUEST_SEARCH'
  }
}

export const clearSearch = () => {
  return {
    type: 'CLEAR_SEARCH'
  }
}

export const saveFilters = (payload) => {
  return {
    type: 'SAVE_FILTERS',
    payload
  }
}

export const resetFilters = () => {
  return {
    type: 'RESET_FILTERS'
  }
}

export const resetIndividualFilter = (payload) => {
  // resets individual traveling to filters.
  return {
    type: 'RESET_INDIVIDUAL_FILTER',
    payload
  }
}

export const storeProfileSearch = (payload) => {
  return {
    type: 'STORE_PROFILE_SEARCH',
    payload
  }
}

export const storeTripSearch = (payload) => {
  return {
    type: 'STORE_TRIP_SEARCH',
    payload
  }
}

export const storeProfileSearchFavChange = (payload) => {
  return {
    type: 'STORE_SEARCH_FAV_CHANGE',
    payload
  }
}

export const storeTripDestinationPhoto = (payload) => {
  return {
    type: 'STORE_DESTINATION_PHOTO',
    payload
  }
}

export const storeSearchIndexSection = (reducerKey,data) => {
  return {
    type: 'STORE_SEARCH_INDEX_SECTION',
    payload: {reducerKey,data}
  }
}

export const profileSearch = (formData,firstCall=true) => {
  return (dispatch, getState) => {

    let pageToGet = 0;
    if(firstCall) { dispatch(clearSearch()); }
    else { pageToGet = getState().meta.search_current_page+1; }
    dispatch(requestSearch());

    // use incoming formData (if the storeLOcation is "online" or "newest")
    // otherwise use search filters.
    var dataToSend = Object.assign({},getState().search.filters);

    return sdk.profileSearch(getState().auth.jwToken,dataToSend,pageToGet)
              .then((response) => {
                dispatch(storeProfileSearch(response.data.data));

                // store pagination
                let page = response.data.meta.pagination;
                dispatch(storeMeta({search_current_page: page.current_page, search_total_pages: page.total_pages}));
              })
              .catch((error) => {
                // unable to load profile search
              });
  }
}

export const tripSearch = (formData,firstCall=true) => {
  return (dispatch, getState) => {

    let pageToGet = 0;
    if(firstCall) { dispatch(clearSearch()); }
    else { pageToGet = getState().meta.search_current_page+1; }
    dispatch(requestSearch());

    return sdk.tripSearch(getState().auth.jwToken,getState().search.filters,pageToGet)
              .then((response) => {
                dispatch(storeTripSearch(response.data.data));

                // store pagination
                let page = response.data.meta.pagination;
                dispatch(storeMeta({search_current_page: page.current_page, search_total_pages: page.total_pages}));
              })
              .catch((error) => {
                // unable to load profile search
              });
  }
}

export const getTripDestinationPhoto = (lat, lng) => {
  return (dispatch, getState) => {
    return sdk.getDestinationPhoto(getState().auth.jwToken, lat, lng)
      .then( (response) => {
        if(response.data.data && response.data.data[0]) {
          dispatch(storeTripDestinationPhoto(response.data.data[0].path));
        }
      })
      .catch( (error) => {
        console.error(error);
      })
  }
}


export const getSearchIndexSection = (which_section) => {
  return (dispatch, getState) => {
    switch(which_section) {
      case 'search_explore_members':
        var dataToSend = Object.assign({},{distance: 100});
        return sdk.profileSearch(getState().auth.jwToken,dataToSend)
          .then((response) => {
            dispatch(storeSearchIndexSection(which_section,response.data.data));
          });
      break;
      case 'search_upcoming_trips':
        // default trip search
        return sdk.tripSearch(getState().auth.jwToken,getState().search.defaultFilters)
          .then((response) => {
            dispatch(storeSearchIndexSection(which_section,response.data.data));
          });
      break;
      case 'search_top_destinations':
        // add search top destinations
      break;
      case 'search_people_near_me':
        // default people search.
        var dataToSend = Object.assign({},getState().search.defaultFilters);
        return sdk.profileSearch(getState().auth.jwToken,dataToSend)
          .then((response) => {
            dispatch(storeSearchIndexSection(which_section,response.data.data));
          });
      break;            
    }
  }
}


// WEBPACK FOOTER //
// ./src/actions/searchActions.js